import { ReactNode } from "react";
import { PRODUCT_ACCENT_COLORS } from "src/constants/productLogos";

export interface NavLink {
  id: string;
  label?: string;
  url?: string;
  icon?: ReactNode;
}

export interface ProductDropdownItem {
  id: string | number;
  name: string;
  icon?: string;
  accentColor?: string;
  link?: string;
}

export interface WorkspaceSidebarProps {
  navItems: NavLink[];
  selectedItem?: string;
  onSelect: (url: string) => void;
  workspaceName: string;
  workspaceIconSrc?: string;
  workspaceAccentColor?: string;
  showProductSwitcher?: boolean;
  groupIcon?: ReactNode;
  isProductDropdownOpen?: boolean;
  productItems?: ProductDropdownItem[];
  onProductSwitcherClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onProductSelect?: (item: ProductDropdownItem) => void;
  userName?: string;
  userRole?: string;
  onSettingsClick?: () => void;
  settingsLabel?: string;
}

export const SIDEBAR_WIDTH = 260;
export const WORKSPACE_ACCENT_DEVICE_MANAGER = PRODUCT_ACCENT_COLORS.DeviceManager;
